import "../../css/posts.css";

import { ImportAll } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
const postImages = ImportAll(
  require.context("../../assets/posts", false, /\.(png|jpe?g|svg)$/),
);

interface Post {
  external: boolean;
  link: string;
  image: string;
  title: string;
  date: string;
  text: string;
}

interface PostsProps {
  maxPosts?: number;
}

const initialPosts: Post[] = [
  {
    external: false,
    link: "/game-development",
    image: postImages[4],
    title: "Evergrow Update!",
    date: "January 7, 2026",
    text: "We changed the way you see Evergrow: Shards of Tomorrow. A new perspective camera, refined gameplay, and new minigames bring you deeper into the mystery.",
  },
  {
    external: true,
    link: "https://vertexhorizons.gumroad.com/l/CurveMancer?layout=profile",
    image: postImages[3],
    title: "CurveMancer! Your Ultimate Spline Tool!",
    date: "October 10, 2025",
    text: "A pipeline-agnostic Unity editor tool for procedural meshes and prefab placement along splines. Real-time editing, overrides, and full documentation included.",
  },
  {
    external: true,
    link: "https://vertexhorizons.gumroad.com/l/CharController?layout=profile",
    image: postImages[2],
    title: "Free Unity Character Controller!",
    date: "August 5, 2025",
    text: "We’ve released a free Unity NavMesh-based character controller! Learn how to build it from scratch with step-by-step YouTube tutorials, plus free project files.",
  },
  {
    external: false,
    link: "/3dassets",
    image: postImages[1],
    title: "New Modular Kits!",
    date: "June 23, 2025",
    text: "Unleash your creativity with our brand-new modular kits! Designed for maximum flexibility and endless customization, these kits are perfect for builders, hobbyists, and creators alike. Build, mix, and match to bring your unique ideas to life—your imagination is the only limit!",
  },
  {
    external: true,
    link: "https://store.steampowered.com/app/3623600/Evergrow_Shards_of_Tomorrow/",
    image: postImages[0],
    title: "Evergrow : Shards Of Tomorrow",
    date: "May 5, 2025",
    text: "Exciting news in the works! We're currently developing Evergrow: Shards Of Tomorrow, a game that will take you on a unique adventure filled with mystery and immersive storytelling. Stay tuned for more updates as we bring this world to life!",
  },
];

const Posts: React.FC<PostsProps> = ({ maxPosts }) => {
  const navigate = useNavigate();

  const postsToRender = maxPosts
    ? initialPosts.slice(0, maxPosts)
    : initialPosts;

  return (
    <div>
      {postsToRender.map((post, index) => (
        <div
          className="post-container"
          key={index}
          onClick={() => {
            if (post.external) {
              window.open(post.link, "_blank", "noopener,noreferrer");
            } else {
              navigate(post.link);
            }
          }}
        >
          <div className="post-image-container">
            <img src={post.image} alt={post.title} className="post-image" />
          </div>
          <div className="post-text-container">
            <h2 className="post-title">{post.title}</h2>
            <div className="post-date">{post.date}</div>
            <p className="post-text">{post.text}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Posts;
